<template>
<v-container class="mt-3">
    <div>
        <v-data-table
            :headers="headers"
            :items="hospitals"
            :page.sync="page"
            :items-per-page="5"
            :search="search"
            @page-count="pageCount = $event"
            class="text-left elevation-1 pa-3 font-weight-regular blue--text text--darken-4">
            <template #top>
                <v-toolbar flat color="white">

                    <v-toolbar-title>
                        Hospital
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn
                        color="primary font-weight-regular"
                        dark
                        class="mb-2"
                        @click="$router.push('/newhospital')">
                        <v-icon size="25" left>add</v-icon>
                        Adicionar novo
                    </v-btn>

                </v-toolbar>

                <v-spacer></v-spacer>

                <v-text-field
                    class="mx-4 mb-5"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details>
                </v-text-field>
            </template>

          <template v-slot:[`item.status`]="{ item }">
            <v-chip
              :class="getTextColor(item.status)"
              label
              :color="getColor(item.status)"
              dark>
              {{ item.status && item.status === 1 ? "Ativo": item.status === 0 ? "Desativado" : "Pendente" }}
            </v-chip>
          </template>

            <template v-slot:[`item.location`]="{ item }">
                <span>{{item.location ? item.location : "Manaus"}}</span>
            </template>

            <template v-slot:[`item.category`]="{ item }">
                <span>{{item.category ? item.category : "HPS"}}</span>
            </template>

            <template v-slot:[`item.created_at`]="{ item }">
                <span>{{formatDate(item.created_at)}}</span>
            </template>

            <template v-slot:[`item.actions`]="{ item }">

                <v-icon
                    class="mr-2"
                    @click="editItem(item)">
                    mdi-pencil
                </v-icon>

              <v-tooltip v-if="item.status === 1" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="error" @click="disableItem(item)">apartment</v-icon>
                </template>
                <span>Desabilitar hospital</span>
              </v-tooltip>
              <v-tooltip v-else top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="success" v-bind="attrs" v-on="on" @click="enableItem(item)">apartment</v-icon>
                </template>
                <span>Habilitar hospital</span>
              </v-tooltip>

            </template>
        </v-data-table>

        <div class="text-center pt-2">
            <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
    </div>
</v-container>
</template>

<script>
const moment = require('moment');
export default {
    data: () => ({
        dialog: false,
        search:'',
        page: 1,
        pageCount: 0,
        headers: [
            { text: 'Nome', align: 'start', sortable: false, value: 'name',},
            { text: 'Status', value: 'status', sortable: false },
            { text: 'Localização', value: 'location', sortable: false },
            { text: 'Categoria', value: 'category', sortable: false },
            { text: 'Data de registro', value: 'created_at', sortable: false },
            { text: 'Ações', value: 'actions', sortable: false },
        ],
    }),

    async created(){
        await this.inicialize();
    },

    computed: {

        hospitals(){
            let hospitals = this.$store.getters.hospitals ? this.$store.getters.hospitals:[];
            return hospitals;
        }
    },

    methods: {

        async inicialize (){
            await this.$store.dispatch('loadHospitals');
        },

        formatDate (date){
            return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY');
        },

        editItem (item) {
            console.log(item)
            this.$store.dispatch('setSelectedHospital',item)
            this.$router.push(`/edithospital/${0}`)
        },

      getColor (status) {

        if (status === 1) return 'green lighten-4'
        else if (status === 0) return 'red lighten-4'
        else return 'amber lighten-4'
      },

      getTextColor (status) {

        if (status === 1) return 'green--text'
        else if (status === 0) return 'red--text'
        else return 'orange--text'
      },
      async disableItem (item) {
        console.log('Verificar se API foi atualizado',item)
        item.status = 0;
        let novo = {
            status: item.status,
            id: item.id
        }
        let res = await this.$store.dispatch('editHospital', novo);
      },

      async enableItem (item) {
        console.log('Verificar se API foi atualizado',item)
        item.status = 1;
        let novo = {
            status: item.status,
            id: item.id
        }
        let res = await this.$store.dispatch('editHospital', novo);
      },

        async deleteItem (item) {

            if(confirm('Você realmente deseja remover esse hospital ?')){
                await this.$store.dispatch('removeHospital',item.id)
                    .then( response => {
                        if(!response.message){
                            this.inicialize();
                        }else{
                            //TODO: houve erro, criar uma mensagem pro usuário
                        }
                    })
            }
        },
    },
}
</script>

<style scoped>
</style>
